'use strict';


angular.module('amexReconciliationApp')
  .service('ActiveTransactionAllocationsService', function ($rootScope, $resource, $q) {
    var allocationsResource = $resource('/api/v1/transactions/:transactionId/allocations',
      undefined,
      {
        get: {method: 'GET'},
        update: {method: 'PUT', isArray: true }
      }
    );

    this.fetchAllocations = function (transaction) {
      if (transaction === undefined) {
        return $q.when([]);
      }
      return allocationsResource.get({transactionId: transaction.id}).$promise.then(function(data){
        return _.get(data._embedded, 'allocations', []);
      });
    };

    this.saveAllocations = function saveAllocations(transaction, allocations) {
      return allocationsResource.update({transactionId: transaction.id}, allocations).$promise;
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/ActiveTransactionAllocationsService.js
// module id = 632
// module chunks = 0